import { render, staticRenderFns } from "./JDRow.vue?vue&type=template&id=5a30c04d&scoped=true&"
import script from "./JDRow.vue?vue&type=script&lang=js&"
export * from "./JDRow.vue?vue&type=script&lang=js&"
import style0 from "./JDRow.vue?vue&type=style&index=0&id=5a30c04d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a30c04d",
  null
  
)

export default component.exports